// extracted by mini-css-extract-plugin
export default {"wrapper":"CompetenceMonthFilter_wrapper__1Nb2a","input":"CompetenceMonthFilter_input__QKV8i"};